<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper" v-if="Object.keys(contactData).length">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <Form @submit="updateContract" :validation-schema="schema">
            <div class="contact-head">
              <div class="row align-items-center">
                <div class="col-sm-6">
                  <ul class="contact-breadcrumb">
                    <li>
                      <button type="submit" class="custom-header-button"> <i class="ti ti-check"></i>
                        Save
                      </button>
                    </li>
                    <li>
                      <router-link
                        :to="{ path: '/crm/organisation-details', query: { ter_Id: terId, org_Id: orgId, contract_Id: formData.id, for: 'contracts' } }">
                        <i class="ti ti-arrow-narrow-left"></i>
                        Organisation
                      </router-link>
                    </li>
                    <li>
                      <router-link to='/crm/contracts-list'>
                        <i class="ti ti-arrow-narrow-left"></i>
                        List
                      </router-link>
                    </li>
                    <!-- <li>Edit Contract</li> --> 
                  </ul>
                </div>
              </div>
            </div>
            <send-loa v-if="opportunityData && Object.keys(opportunityData).length" :orgPersons="orgPersons"
              :opportunityData="opportunityData" :settingOptions="settingOptions" :contactPerson="orgPersonsDetails"
              :contractContactId="orgPersonsDetails.id"></send-loa>
            <div class="row">
              <div class="col-xl-12 col-lg-12">
                <div class="card">
                  <div class="card-body settings-form">
                    <!-- <Form @submit="updateContract"> -->
                    <div class="settings-sub-header">
                      <div class="row align-items-center mx-0">
                        <div class="col-md-6 col-8">
                          <h4> Contract - {{ formData.contract_number }} | Edit</h4>
                        </div>
                        <div class="col-md-6 col-4 text-end contact-head">
                          <ul class="contact-breadcrumb">
                            <li class="mb-0" v-if="user.roles?.includes('company_admin')">
                                <router-link
                                    :to="{ path: '/crm/move', query: { entity_id: formData.id, 'entityType':'contract'} }"
                                    title="move"><i
                                        class="ti ti-arrows-move"></i>
                                </router-link>
                            </li>
                            <li class="mb-0" v-if="orgPersonsDetails.id !== ''">
                              <router-link
                                :to="{ path: '/crm/create-organisation', query: { org_Id: orgId, ter_Id: terId, contract_Id: formData.id, add: 'editContract', for: 'contracts' } }"
                                :title="'Edit' + ' ' + orgPersonsDetails.first_name + ' ' + orgPersonsDetails.last_name"><i
                                  class="ti ti-user-edit"></i> </router-link>
                            </li>
                            <li class="mb-0"
                              v-if="(companyType === 'partnership') || (companyType !== 'partnership' && orgPersons.length === 0) || (orgPersons.length !== 0 && companyType === 'partnership')">
                              <router-link title="Add Person" :to="{
                                path: '/crm/create-organisation',
                                query: { org_Id: orgId, ter_Id: terId, contract_Id: formData.id, add: 'editContract', for: 'contracts' },
                              }"><i class="ti ti-user-plus"></i></router-link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="row organisation-details-section mt-2" v-if="Object.keys(org_details).length">
                        <div class="col-md-6">
                          <h4 class="d-flex align-items-center my-2">
                          <span class="text-teal" role="button" :title="orgPersonsDetails.email"
                              @click="handleEmailClick(orgPersonsDetails.email)"
                              style="font-size: 25px; margin-right: 7px;">@</span>
                            <router-link
                              :to="{ path: '/crm/organisation-details', query: { ter_Id: terId, org_Id: orgId, for: 'contracts' } }"
                              class="website me-2">
                              www
                            </router-link> {{ org_details.name }}
                            <!-- <a class="website me-2" :href="org_details.www">www</a>{{ org_details.name }} -->
                          </h4>
                          <!-- <p title="Postcode" v-if="org_details.postcode">{{ org_details.postcode }}</p> -->
                            <p title="Address" v-if="complete_address"> {{ complete_address }}
                          </p>
                          <p title="Contact Person Name" v-if="orgPersonsDetails">
                            {{
                              orgPersonsDetails.salutation + ' ' +
                              orgPersonsDetails.first_name + ' ' +
                              orgPersonsDetails.last_name +
                            (orgPersonsDetails.job_title ? ` ( ${orgPersonsDetails.job_title} )` : '')
                            }}
                          </p>
                          <p v-if="org_details.telephone">
                            T: <span title="Organisation telephone">{{
                              org_details.telephone }} </span>
                              <!-- <span title="Contact landline">{{
                                orgPersonsDetails.landline }}</span> -->
                            <!-- T: <span title="Contact landline">{{
                              orgPersonsDetails.landline }}</span> -->
                          </p>
                          <!-- <p title="Contact mobile" v-if="orgPersonsDetails.mobile_telephone">
                            M: {{ orgPersonsDetails.mobile_telephone }}
                          </p> -->

                          <p title="Person Direct Line" v-if="orgPersonsDetails.direct_line">
                            D: {{ orgPersonsDetails.direct_line }}
                          </p>
                          <p title="Person Landline" v-if="orgPersonsDetails.landline">
                            L: {{ orgPersonsDetails.landline }}
                          </p>
                          <p title="Person mobile" v-if="orgPersonsDetails.mobile_telephone">
                            M: {{ orgPersonsDetails.mobile_telephone }}
                          </p>
                          <p title="Tps" v-if="
                            org_details?.tps
                          ">
                            TPS: {{
                              (org_details?.tps || "N/A")
                            }}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <div class="form-wrap mb-0">
                            <label class="col-form-label">Comment </label>
                            <textarea class="form-control" rows="4" v-model="formData.opportunity.comment"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pro-create mb-2">
                      <div class="contract-won-row">
                        <div class="row mx-0 py-2">
                          <div :class="user.roles[0] === 'company_admin' ? 'col-lg-3 col-md-4' : 'col-md-3'">
                            <div class="form-wrap">
                              <label class="col-form-label">Date of Sale</label>
                              <div class="icon-form">
                                <date-time-picker
                                  v-model="formData.opportunity.date_of_sale"
                                  text-input
                                  format="dd/MM/yyyy"
                                  auto-apply
                                  :enable-time-picker="false"
                                  :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'"
                                  :clearable="user.roles[0] === 'company_admin' || user.roles[0] === 'cm_responsible'"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">Sales responsible </label>
                              <Field as="select" name="sales_responsible" class="form-select"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.sales_responsible"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'">
                                <option value="">-----Select-----</option>
                                <option v-for="res in saleResponsibleOptions" :key="res.id" :value="res.id">
                                  {{ res.name }}
                                </option>
                              </Field>
                            </div>
                          </div>
                          <div
                            :class="user.roles[0] === 'company_admin' || user.roles[0] === 'cm_responsible' ? 'col-lg-3 col-md-4' : 'col-md-3'">
                            <div class="form-wrap">
                              <label class="col-form-label">Referred By</label>
                              <Field as="select" name="referred_by" class="form-select"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.referred_by"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'">
                                <option value="">-----Select-----</option>
                                <option v-for="res in saleResponsibleOptions" :key="res.id" :value="res.id">
                                  {{ res.name }}
                                </option>
                              </Field>
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">Opp Type </label>
                              <Field name="opp_type" as="input" type="text" class="form-control" disabled
                                v-model="formData.opportunity.opp_type" />
                            </div>
                          </div>
                          <!-- @change="fetchWinProb" -->
                          <div class="col-lg-3 col-md-4"
                            v-if="user.roles[0] === 'company_admin' || user.roles[0] === 'cm_responsible'">
                            <div class="form-wrap">
                              <label class="col-form-label">Revert to meter opportunity <span
                                  class="text-danger"></span></label>
                              <Field as="select" name="revert_to_meter_opportunity" class="form-select"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.revert_to_meter_opportunity"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'">
                                <option value="">-----Select-----</option>
                                <option v-for="res in pipelineLevels" :key="res.id" :value="res.id">
                                  {{ res.name }}
                                </option>
                              </Field>
                            </div>
                          </div>
                        </div>
                        <div class="row mx-0 py-2">
                          <div class="col-lg-3 col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">SC Commission</label>
                              <Field type="text" as="input" name="sc_forecast_total_commission" class="form-control"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.sc_forecast_total_commission"
                                @keypress="$utils.allowOnlyNumbers"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'" ></Field>
                              <span class="text-danger"
                                v-if="apiErrors && apiErrors['sc_forecast_total_commission'] && apiErrors['sc_forecast_total_commission'].length">
                                {{ apiErrors['sc_forecast_total_commission'][0] }}
                              </span>
                              <ErrorMessage name="sc_forecast_total_commission" class="text-danger" />
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">SC Consumption</label>
                              <Field type="text" as="input" name="quoted_annual_consumption" class="form-control"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.quoted_annual_consumption"
                                @keypress="$utils.allowOnlyNumbers"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'" ></Field>
                              <span class="text-danger"
                                v-if="apiErrors && apiErrors['quoted_annual_consumption'] && apiErrors['quoted_annual_consumption'].length">
                                {{ apiErrors['quoted_annual_consumption'][0] }}
                              </span>
                              <ErrorMessage name="quoted_annual_consumption" class="text-danger" />
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">Consumption Source</label>
                              <Field as="select" name="consumption_source" class="form-select"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.consumption_source"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'">
                                <option value="">-----Select-----</option>
                                <option v-for="res in options.opp_consumption_source" :key="res.value"
                                  :value="res.value">
                                  {{ res.text }}
                                </option>
                              </Field>
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">U4B Uplift</label>
                              <input name="u4b_uplift" type="text" class="form-control"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formattedData.u4b_uplift"
                                @blur="updateFormData('u4b_uplift', formattedData.u4b_uplift)"
                                @focus="formattedData.u4b_uplift = formatNumber(formData.opportunity.forecast_commission.u4b_uplift)"
                                @keypress="$utils.allowOnlyNumbers"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'" />
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">Term <span class="text-danger" v-if="
                                isNotValid && (formData.opportunity.term === null || formData.opportunity.term === '')
                              ">*</span></label>
                              <Field name="term" as="input" type="text" class="form-control"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.term"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'" />
                              <!-- <span class="text-danger" v-if="
                                isNotValid && (formData.opportunity.term === null || formData.opportunity.term === '')
                              ">Term is required</span> -->
                            </div>
                          </div>
                        </div>
                        <div class="row mx-0 py-2">
                          <div class="col-lg-3 col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">CED</label>
                              <div class="icon-form">
                                <date-time-picker
                                  v-model="formData.opportunity.contract_end_date"
                                  text-input
                                  format="dd/MM/yyyy"
                                  auto-apply
                                  :enable-time-picker="false"
                                  :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'"
                                  :clearable="user.roles[0] === 'company_admin' || user.roles[0] === 'cm_responsible'"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">NIC</label>
                              <Field as="select" name="nic" class="form-select"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.nic"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'">
                                <option value="">-----Select-----</option>
                                <option v-for="res in yesNoOptions" :key="res" :value="res">
                                  {{ res }}
                                </option>
                              </Field>
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">COT</label>
                              <Field as="select" name="cot" class="form-select"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.cot"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'">
                                <option value="">-----Select-----</option>
                                <option v-for="res in yesNoOptions" :key="res" :value="res">
                                  {{ res }}
                                </option>
                              </Field>
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">COT Date</label>
                              <div class="icon-form">
                                <date-time-picker
                                  v-model="formData.opportunity.cot_date"
                                  text-input
                                  format="dd/MM/yyyy"
                                  auto-apply
                                  :enable-time-picker="false"
                                  :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'"
                                  :clearable="user.roles[0] === 'company_admin' || user.roles[0] === 'cm_responsible'"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">Current Supplier </label>
                              <vue-select :options="supplierOptions" :key="supplierOptions.id" :id="supplierOptions.id"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.supplier_id" placeholder="Search Supplier....."
                                @select="myChangeEvent($event, 'current')"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'"
                                autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">New Supplier </label>
                              <vue-select :options="supplierOptions" :key="supplierOptions.id" :id="supplierOptions.id"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.new_supplier_id" placeholder="Search Supplier....."
                                @select="myChangeEvent($event, 'new')"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'"
                                autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />
                            </div>
                          </div>
                          <div class="col-lg-3 col-md-4">
                            <div class="form-wrap">
                              <label class="col-form-label">Sale Type</label>
                              <Field as="select" name="sale_type" class="form-select"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.sale_type"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'">
                                <option value="">-----Select-----</option>
                                <option v-for="res in options.op_sales_type" :key="res.value" :value="res.value">
                                  {{ res.text }}
                                </option>
                              </Field>
                            </div>
                          </div>

                          <div class="col-lg-3 col-md-4"
                            v-if="formData.opportunity.main_production_service?.toLowerCase() === 'gas' || supplierName !== 'Pozitive Energy'">
                            <div class="form-wrap">
                              <label class="col-form-label">Standing Charge</label>
                              <Field as="input" type="text" name="standing_charge" class="form-control"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.quotes.standing_charge"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'">
                              </Field>
                            </div>
                          </div>

                          <div class="col-lg-3 col-md-4"
                            v-if="formData.opportunity.main_production_service?.toLowerCase() === 'gas' || supplierName !== 'Pozitive Energy'">
                            <div class="form-wrap">
                              <label class="col-form-label">Day Unit Rate</label>
                              <Field as="input" type="text" name="day_unit_rate" class="form-control"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.quotes.day_unit_rate"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'">
                              </Field>
                            </div>
                          </div>

                          <div class="col-lg-3 col-md-4"
                            v-if="formData.opportunity.main_production_service?.toLowerCase() === 'elec' && supplierName !== 'Pozitive Energy'">
                            <div class="form-wrap">
                              <label class="col-form-label">Night Unit Rate</label>
                              <Field as="input" type="text" name="night_unit_rate" class="form-control"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.quotes.night_unit_rate"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'">
                              </Field>
                            </div>
                          </div>

                          <div class="col-lg-3 col-md-4"
                            v-if="formData.opportunity.main_production_service?.toLowerCase() === 'elec' && supplierName !== 'Pozitive Energy'">
                            <div class="form-wrap">
                              <label class="col-form-label">Evening & Weekend</label>
                              <Field as="input" type="text" name="evening_and_weekend" class="form-control"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                                v-model="formData.opportunity.quotes.evening_and_weekend"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'">
                              </Field>
                            </div>
                          </div>

                          <div class="col-lg-3 col-md-4"
                            v-if="formData.opportunity.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                            <div class="form-wrap">
                              <label class="col-form-label">Day/All</label>
                              <input type="text" class="form-control"
                                v-model="formData.opportunity.forecast_commission.day_consumption"
                                @keypress="$utils.allowOnlyNumbers" @change="totalConsumption"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }" />
                              <span class="text-danger" v-if="
                                apiErrors &&
                                apiErrors['day_consumption'] &&
                                apiErrors['day_consumption'].length
                              ">
                                {{ apiErrors["day_consumption"][0] }}
                              </span>
                            </div>
                          </div>

                          <div class="col-md-1"
                            v-if="formData.opportunity.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                            <div class="form-wrap">
                              <label class="col-form-label">Uplift Day/ALL</label>
                              <input type="text" class="form-control"
                                v-model="formData.opportunity.forecast_commission.day_uplift"
                                @keypress="$utils.allowOnlyNumbers"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }" />
                              <span class="text-danger" v-if="
                                apiErrors &&
                                apiErrors['day_uplift'] &&
                                apiErrors['day_uplift'].length
                              ">
                                {{ apiErrors["day_uplift"][0] }}
                              </span>
                            </div>
                          </div>

                          <div class="col-md-2"
                            v-if="formData.opportunity.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                            <div class="form-wrap">
                              <label class="col-form-label">Night</label>
                              <input type="text" class="form-control"
                                v-model="formData.opportunity.forecast_commission.night_consumption"
                                @keypress="$utils.allowOnlyNumbers" @change="totalConsumption"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }" />
                              <span class="text-danger" v-if="
                                apiErrors &&
                                apiErrors['night_consumption'] &&
                                apiErrors['night_consumption'].length
                              ">
                                {{ apiErrors["night_consumption"][0] }}
                              </span>
                            </div>
                          </div>

                          <div class="col-md-1"
                            v-if="formData.opportunity.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                            <div class="form-wrap">
                              <label class="col-form-label">Uplift Night</label>
                              <input type="text" class="form-control"
                                v-model="formData.opportunity.forecast_commission.night_uplift"
                                @keypress="$utils.allowOnlyNumbers"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }" />
                              <span class="text-danger" v-if="
                                apiErrors &&
                                apiErrors['night_uplift'] &&
                                apiErrors['night_uplift'].length
                              ">
                                {{ apiErrors["night_uplift"][0] }}
                              </span>
                            </div>
                          </div>

                          <div class="col-md-2"
                            v-if="formData.opportunity.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                            <div class="form-wrap">
                              <label class="col-form-label">Evening/Weekend</label>
                              <input type="text" class="form-control"
                                v-model="formData.opportunity.forecast_commission.weekend_consumption"
                                @keypress="$utils.allowOnlyNumbers" @change="totalConsumption"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }" />
                              <span class="text-danger" v-if="
                                apiErrors &&
                                apiErrors['weekend_consumption'] &&
                                apiErrors['weekend_consumption'].length
                              ">
                                {{ apiErrors["weekend_consumption"][0] }}
                              </span>
                            </div>
                          </div>

                          <div class="col-md-2"
                            v-if="formData.opportunity.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                            <div class="form-wrap">
                              <label class="col-form-label">Uplift Evening/Weekend</label>
                              <input type="text" class="form-control"
                                v-model="formData.opportunity.forecast_commission.weekend_uplift"
                                @keypress="$utils.allowOnlyNumbers"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }" />
                              <span class="text-danger" v-if="
                                apiErrors &&
                                apiErrors['weekend_uplift'] &&
                                apiErrors['weekend_uplift'].length
                              ">
                                {{ apiErrors["weekend_uplift"][0] }}
                              </span>
                            </div>
                          </div>

                          <div class="col-md-2"
                            v-if="formData.opportunity.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                            <div class="form-wrap">
                              <label class="col-form-label">Uplift Standing charge</label>
                              <input type="text" class="form-control"
                                v-model="formData.opportunity.forecast_commission.uplift_standing_charge"
                                @keypress="$utils.allowOnlyNumbers"
                                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }" />
                              <span class="text-danger" v-if="
                                apiErrors &&
                                apiErrors['uplift_standing_charge'] &&
                                apiErrors['uplift_standing_charge'].length
                              ">
                                {{ apiErrors["uplift_standing_charge"][0] }}
                              </span>
                            </div>
                          </div>

                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">CM Responsible </label>
                            <Field as="select" name="cm_responsible" class="form-select"
                              v-model="formData.opportunity.cm_responsible">
                              <option value="">-----Select-----</option>
                              <option v-for="res in cmResponsibleOptions" :key="res.id" :value="res.id">
                                {{ res.name }}
                              </option>
                            </Field>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">CM Date</label>
                            <Field name="cm_date" class="form-select" v-model="formData.cm_date">
                            <div class="icon-form">
                              <date-time-picker
                                v-model="formData.cm_date"
                                text-input
                                format="dd/MM/yyyy"
                                auto-apply
                                :enable-time-picker="false"
                                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'"
                                :clearable="user.roles[0] === 'company_admin' || user.roles[0] === 'cm_responsible'"
                              />
                            </div>
                            <ErrorMessage name="cm_date" class="text-danger" />
                            </Field>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">Contract U4B Status</label>
                            <Field as="select" name="u4b_status" class="form-select" v-model="formData.u4b_status"
                              :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                              @change="closeLost"
                              :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'">
                              <option value="">-----Select-----</option>
                              <option v-for="res in contractOptions.contract_u4b_status" :key="res.value"
                                :value="res.value">
                                {{ res.text }}
                              </option>
                            </Field>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">Status Date</label>
                            <div class="icon-form">
                              <date-time-picker
                                v-model="formData.u4b_status_changed_at"
                                text-input
                                format="dd/MM/yyyy"
                                auto-apply
                                :enable-time-picker="false"
                                :disabled=false
                                :clearable=true
                              />
                            </div>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">Department to Resolve</label>
                            <Field as="select" name="department_to_resolve" class="form-select"
                              v-model="formData.department_to_resolve">
                              <option value="">-----Select-----</option>
                              <option v-for="res in contractOptions.department_to_resolve" :key="res.value"
                                :value="res.value">
                                {{ res.text }}
                              </option>
                            </Field>
                            <ErrorMessage name="department_to_resolve" class="text-danger" />
                            <span class="text-danger"
                              v-if="apiErrors && apiErrors['department_to_resolve'] && apiErrors['department_to_resolve'].length">
                              {{ apiErrors['department_to_resolve'][0] }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">Submitted Via</label>
                            <Field name="submitted_via" as="input" type="text" class="form-control"
                              v-model="formData.submitted_via" />
                            <ErrorMessage name="submitted_via" class="text-danger" />
                            <span class="text-danger"
                              v-if="apiErrors && apiErrors['submitted_via'] && apiErrors['submitted_via'].length">
                              {{ apiErrors['submitted_via'][0] }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">TERM/COT</label>
                            <Field as="select" name="term_cot" class="form-select"
                              v-model="formData.term_cot"
                              @change="onTermCotChange">
                              <option value="">-----Select-----</option>
                              <option v-for="res in contractOptions.term_cot" :key="res.value"
                                :value="res.value">
                                {{ res.text }}
                              </option>
                            </Field>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">TERM Status</label>
                            <Field as="select" name="term_status" class="form-select"
                              :class="{ 'disable': !isTermStatusEnterable }"
                              :disabled="!isTermStatusEnterable"
                              v-model="formData.term_status">
                              <option value="">-----Select-----</option>
                              <option v-for="res in contractOptions.term_status" :key="res.value"
                                :value="res.value">
                                {{ res.text }}
                              </option>
                            </Field>
                            <ErrorMessage name="term_status" class="text-danger" />
                            <span class="text-danger"
                              v-if="apiErrors && apiErrors['term_status'] && apiErrors['term_status'].length">
                              {{ apiErrors['term_status'][0] }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">COT Status</label>
                            <Field as="select" name="cot_status" class="form-select"
                              :class="{ 'disable': !isCotStatusEnterable }"
                              :disabled="!isCotStatusEnterable"
                              v-model="formData.cot_status">
                              <option value="">-----Select-----</option>
                              <option v-for="res in contractOptions.cot_status" :key="res.value"
                                :value="res.value">
                                {{ res.text }}
                              </option>
                            </Field>
                            <ErrorMessage name="cot_status" class="text-danger" />
                            <span class="text-danger"
                              v-if="apiErrors && apiErrors['cot_status'] && apiErrors['cot_status'].length">
                              {{ apiErrors['cot_status'][0] }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">TERM/COT Followup Date</label>
                            <Field name="term_cot_followup_date" class="form-select" v-model="formData.term_cot_followup_date">
                              <div class="icon-form">
                                <date-time-picker
                                  v-model="formData.term_cot_followup_date"
                                  text-input
                                  format="dd/MM/yyyy"
                                  auto-apply
                                  :enable-time-picker="false"
                                  :disabled="false"
                                  :clearable="true"
                                />
                              </div>
                            </Field>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">Start Date</label>
                          <Field name="contract_start_date" class="form-select" v-model="formData.opportunity.contract_start_date">
                            <div class="icon-form">
                              <date-time-picker
                                v-model="formData.opportunity.contract_start_date"
                                text-input
                                format="dd/MM/yyyy"
                                auto-apply
                                :enable-time-picker="false"
                                :disabled=false
                                :clearable=true
                              />
                            </div>
                          </Field>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">Submission ID</label>
                            <Field name="submission_id" as="input" type="text" class="form-control"
                              v-model="formData.submission_id" />
                            <ErrorMessage name="submission_id" class="text-danger" />
                            <span class="text-danger"
                              v-if="apiErrors && apiErrors['submitted_via'] && apiErrors['submission_id'].length">
                              {{ apiErrors['submission_id'][0] }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">LOA Status</label>
                            <Field name="loa_status" as="input" type="text" class="form-control"
                              v-model="formData.opportunity.loa_status" />
                            <ErrorMessage name="loa_status" class="text-danger" />
                            <span class="text-danger"
                              v-if="apiErrors && apiErrors['submitted_via'] && apiErrors['opportunity.loa_status'].length">
                              {{ apiErrors['opportunity.loa_status'][0] }}
                            </span>
                          </div>
                        </div>
                        <!-- Term Resp replaced by TERM/COT on this page; column kept for data/reports -->
                        <!-- <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">Term Resp</label>
                            <Field as="select" name="termination_responsible" class="form-select"
                              v-model="formData.termination_responsible">
                              <option value="">-----Select-----</option>
                              <option v-for="res in contractOptions.termination_responsible" :key="res.value"
                                :value="res.value">
                                {{ res.text }}
                              </option>
                            </Field>
                          </div>
                        </div> -->
                      </div>
                      <div class="row mt-2">
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">Main product/service</label>
                            <Field as="select" name="main_production_service" class="form-select"
                              :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                              v-model="formData.opportunity.main_production_service"
                              :disabled="user.roles[0] !== 'company_admin'">
                              <option value="">-----Select-----</option>
                              <option v-for="res in options.op_product" :key="res.value" :value="res.value">
                                {{ res.text }}
                              </option>
                            </Field>
                          </div>
                        </div>
                        <div class="col-md-2"
                          v-if="formData.opportunity.main_production_service?.toLowerCase() === 'elec'">
                          <div class="form-wrap">
                            <label class="col-form-label">Top Line</label>
                            <Field name="mpan_top" as="input" type="text" class="form-control"
                              v-model="formData.opportunity.mpan_top" />
                            <ErrorMessage name="mpan_top" class="text-danger" />
                            <span class="text-danger"
                              v-if="apiErrors && apiErrors['opportunity.mpan_top'] && apiErrors['opportunity.mpan_top'].length">
                              {{ apiErrors['opportunity.mpan_top'][0] }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-3"
                          v-if="formData.opportunity.main_production_service?.toLowerCase() === 'elec'">
                          <div class="form-wrap">
                            <label class="col-form-label">Bottom Line</label>
                            <Field name="mpan_bottom" as="input" type="text" class="form-control"
                              v-model="formData.opportunity.mpan_bottom" />
                            <ErrorMessage name="mpan_bottom" class="text-danger" />
                            <span class="text-danger"
                              v-if="apiErrors && apiErrors['opportunity.mpan_bottom'] && apiErrors['opportunity.mpan_bottom'].length">
                              {{ apiErrors['opportunity.mpan_bottom'][0] }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-3"
                          v-if="formData.opportunity.main_production_service?.toLowerCase() === 'gas'">
                          <div class="form-wrap">
                            <label class="col-form-label">MPR NO.</label>
                            <Field name="mpr" as="input" type="text" class="form-control"
                              v-model="formData.opportunity.mpr" />
                            <ErrorMessage name="mpr" class="text-danger" />
                            <span class="text-danger"
                              v-if="apiErrors && apiErrors['opportunity.mpr'] && apiErrors['opportunity.mpr'].length">
                              {{ apiErrors['opportunity.mpr'][0] }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-2"
                          v-if="formData.opportunity.main_production_service?.toLowerCase() === 'elec' && (supplierName !== 'Pozitive Energy' || supplierName === null)">
                          <!-- || formData.opportunity.main_production_service?.toLowerCase() === 'gas' -->
                          <div class="form-wrap">
                            <label class="col-form-label">Consumption</label>
                            <!-- <label class="col-form-label">Day/All</label> -->
                            <input type="text" class="form-control"
                              v-model="formData.opportunity.quoted_annual_consumption"
                              @keypress="$utils.allowOnlyNumbers" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['opportunity.quoted_annual_consumption'] &&
                              apiErrors['opportunity.quoted_annual_consumption'].length
                            ">
                              {{ apiErrors["opportunity.quoted_annual_consumption"][0] }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-2"
                          v-if="formData.opportunity.main_production_service?.toLowerCase() === 'elec'">
                          <div class="form-wrap">
                            <label class="col-form-label">KVA (IF 00)</label>
                            <input name="kva" type="text" class="form-control" v-model="formattedData.kva"
                              @blur="updateFormData('kva', formattedData.kva)"
                              @focus="formattedData.kva = formatNumber(formData.opportunity.forecast_commission.kva)"
                              @keypress="$utils.allowOnlyNumbers" />

                          </div>
                        </div>

                        <div class="col-md-2"
                          v-if="formData.opportunity.main_production_service?.toLowerCase() === 'elec' && supplierName === 'Pozitive Energy'">
                        </div>
                        <div class="col-md-3"
                          v-if="formData.opportunity.main_production_service?.toLowerCase() === 'water'">
                          <div class="form-wrap">
                            <label class="col-form-label">SPID</label>
                            <Field name="spid" as="input" type="text" class="form-control"
                              v-model="formData.opportunity.spid" />
                            <!-- <ErrorMessage name="spid" class="text-danger" /> -->
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['opportunity.spid'] &&
                              apiErrors['opportunity.spid'].length
                            ">
                              {{ apiErrors["opportunity.spid"]?.[0] }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-3"
                          v-if="formData.opportunity.main_production_service?.toLowerCase() === 'water'">
                          <div class="form-wrap">
                            <label class="col-form-label">Water Consumption</label>
                            <input type="text" class="form-control" v-model="formData.opportunity.water_consumption"
                              @keypress="$utils.allowOnlyNumbers" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['.opportunitywater_consumption'] &&
                              apiErrors['opportunity.water_consumption'].length
                            ">
                              {{ apiErrors["opportunity.water_consumption"][0] }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-3"
                          v-if="formData.opportunity.main_production_service?.toLowerCase() === 'water'">
                          <div class="form-wrap">
                            <label class="col-form-label">Waste Consumption</label>
                            <input type="text" class="form-control" v-model="formData.opportunity.waste_consumption"
                              @keypress="$utils.allowOnlyNumbers" />
                            <span class="text-danger" v-if="
                              apiErrors &&
                              apiErrors['opportunity.waste_consumption'] &&
                              apiErrors['opportunity.waste_consumption'].length
                            ">
                              {{ apiErrors["opportunity.waste_consumption"][0] }}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="row align-items-center my-2">
                        <div class="col-md-3">
                          <div class="row align-items-center">
                            <div class="col-md-5">
                              <label class="mb-0">No. of Objections</label>
                            </div>
                            <div class="col-md-7">
                              <div class="row align-items-center">
                                <div class="col-3 p-0">
                                  <input type="number" v-model="objectionValue" class="number_field text-center"
                                    readonly placeholder="0" />
                                </div>
                                <div class="col-2 p-0">
                                  <button @click="adjustObjection(1, $event)"
                                    :class="{ 'disabled': !disabledObjection }" class="btn btn-teal px-2 py-1"><i
                                      class="ti ti-plus"></i></button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="row align-items-center">
                            <div class="col-md-6">
                              <label class="mb-0">No. of Rejections</label>
                            </div>
                            <div class="col-md-6">
                              <div class="row align-items-center">
                                <div class="col-3 p-0">
                                  <input type="number" v-model="rejectionValue" class="number_field text-center"
                                    readonly placeholder="0" />
                                </div>
                                <div class="col-2 p-0">
                                  <button @click="adjustRejection(1, $event)"
                                    :class="{ 'disabled': !disabledRejection }" class="btn btn-teal px-2 py-1"><i
                                      class="ti ti-plus"></i></button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-wrap">
                            <label class="col-form-label">U4B Unique ID</label>
                            <Field name="u4b_unique_id" as="input" type="text" class="form-control"
                              v-model="formData.u4b_unique_id" />
                            <ErrorMessage name="u4b_unique_id" class="text-danger" />
                            <span class="text-danger"
                              v-if="apiErrors && apiErrors['u4b_unique_id'] && apiErrors['u4b_unique_id'].length">
                              {{ apiErrors['u4b_unique_id'][0] }}
                            </span>
                          </div>
                        </div>
                        <div class="col-md-3 text-center">
                          <label class="me-5">
                            <input type="checkbox" v-model="formData.wp_sent" class="checkbox-size" />
                            WP Sent
                          </label>
                        </div>
                      </div>
                      <div class="row align-items-center mt-2">
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">Contract contact</label>
                            <Field as="select" name="contract_contact" class="form-select"
                              v-model="formData.contract_contact">
                              <option value="">-----Select-----</option>
                              <option v-for="res in orgPersons" :key="res.id" :value="res.id">
                                {{ res.name }}
                              </option>
                            </Field>
                          </div>
                        </div>
                        <div class="col-md-2">
                          <div class="form-wrap">
                            <label class="col-form-label">Quotation</label>
                            <input type="text" class="form-control" v-model="formData.opportunity.quotation"
                              :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'" />
                          </div>
                        </div>
                        <div class="col-md-4 text-center pt-2">
                          <label class="me-5">
                            <input type="checkbox" :checked="selectedOption === 'supply'"
                              @change="selectOption('supply')" class="checkbox-size" />
                            Same as Supply Address
                          </label>
                          <label>
                            <input type="checkbox" :checked="selectedOption === 'organisation'"
                              @change="selectOption('organisation')" class="checkbox-size" />
                            Same as Company Address
                          </label>
                        </div>
                        <div class="col-md-4">
                          <div class="form-wrap">
                            <label class="col-form-label">Forecast Annual Consumption</label>
                            <input name="sc_forecast_or_amended_annual_consumption" type="text" class="form-control"
                              v-model="formattedData.sc_forecast_or_amended_annual_consumption"
                              :disabled="formData.opportunity.main_production_service?.toLowerCase() === 'elec' && ['sales_representative'].some(role => user.roles.includes(role))"
                              @keypress="$utils.allowOnlyNumbers"
                              @blur="updateFormData('sc_forecast_or_amended_annual_consumption', formattedData.sc_forecast_or_amended_annual_consumption)"
                              @focus="formattedData.sc_forecast_or_amended_annual_consumption = formatNumber(formData.opportunity.forecast_commission.sc_forecast_or_amended_annual_consumption)" />
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-md-4">
                          <div class="row">
                            <div class="col-md-12 mb-2">
                               <h6 class="text-primary">Supply Address</h6>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Building Name</label>
                                <input type="text" class="form-control"
                                  v-model="formData.opportunity.supply_address.building_name" />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Street </label>
                                <input type="text" class="form-control"
                                  v-model="formData.opportunity.supply_address.street" />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">City</label>
                                <input type="text" class="form-control"
                                  v-model="formData.opportunity.supply_address.city" />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">County</label>
                                <input type="text" class="form-control"
                                  v-model="formData.opportunity.supply_address.county" />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Postcode</label>
                                <input type="text" class="form-control"
                                  v-model="formData.opportunity.supply_address.postcode" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="row">
                            <div class="col-md-12 mb-2">
                               <h6 class="text-primary">Billing Address</h6>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Building Name</label>
                                <Field name="address_line_1" as="input" type="text" class="form-control"
                                  v-model="formData.opportunity.billing_address.address_line_1"
                                  @change="handleChange" />
                                <ErrorMessage name="address_line_1" class="text-danger" />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Street</label>
                                <Field name="address_line_2" as="input" type="text" class="form-control"
                                  v-model="formData.opportunity.billing_address.address_line_2"
                                  @change="handleChange" />
                                <ErrorMessage name="address_line_2" class="text-danger" />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">City</label>
                                <Field name="address_line_3" as="input" type="text" class="form-control"
                                  v-model="formData.opportunity.billing_address.address_line_3"
                                  @change="handleChange" />
                                <ErrorMessage name="address_line_3" class="text-danger" />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">County</label>
                                <Field name="address_line_4" as="input" type="text" class="form-control"
                                  v-model="formData.opportunity.billing_address.address_line_4"
                                  @change="handleChange" />
                                <ErrorMessage name="county" class="text-danger" />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Postcode</label>
                                <Field name="billing_postcode" as="input" type="text" class="form-control"
                                  v-model="formData.opportunity.billing_address.postcode" @change="handleChange" />
                                <ErrorMessage name="billing_postcode" class="text-danger" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-wrap">
                                <label class="col-form-label">Forecast Total Commission</label>
                                <input name="sc_corecast_or_amended_total_commission" type="text" class="form-control"
                                  v-model="formattedData.sc_corecast_or_amended_total_commission"
                                  @blur="updateFormData('sc_corecast_or_amended_total_commission', formattedData.sc_corecast_or_amended_total_commission)"
                                  @focus="formattedData.sc_corecast_or_amended_total_commission = formatNumber(formData.opportunity.forecast_commission.sc_corecast_or_amended_total_commission)"
                                  @keypress="$utils.allowOnlyNumbers" />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="row">
                                <div class="col-12">
                                  <div class="form-wrap">
                                    <label class="col-form-label">Actual Start Date <span class="text-danger" v-if="
                                      isNotValid && (formData.supplier_contract_start_date === null || formData.supplier_contract_start_date === '')
                                    ">*</span></label>
                                    <div class="icon-form">
                                      <date-time-picker
                                        v-model="formData.supplier_contract_start_date"
                                        text-input
                                        format="dd/MM/yyyy"
                                        auto-apply
                                        :enable-time-picker="false"
                                        :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'"
                                        :clearable="user.roles[0] === 'company_admin' || user.roles[0] === 'cm_responsible'"
                                      />
                                    </div>
                                    <!-- <span class="text-danger" v-if="
                                      isNotValid && (formData.supplier_contract_start_date === null || formData.supplier_contract_start_date === '')
                                    ">Actual start date is required</span> -->
                                  </div>
                                </div>
                                <div class="col-12">
                                  <div class="form-wrap">
                                    <label class="col-form-label">New End Date <span class="text-danger" v-if="
                                      isNotValid && (formData.supplier_new_contract_end_date === null || formData.supplier_new_contract_end_date === '')
                                    ">*</span></label>
                                    <div class="icon-form">
                                      <date-time-picker
                                        v-model="formData.supplier_new_contract_end_date"
                                        text-input
                                        format="dd/MM/yyyy"
                                        auto-apply
                                        :enable-time-picker="false"
                                        :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'"
                                        :clearable="user.roles[0] === 'company_admin' || user.roles[0] === 'cm_responsible'"
                                      />
                                    </div>
                                    <!-- <span class="text-danger" v-if="
                                      isNotValid && (formData.supplier_new_contract_end_date === null || formData.supplier_new_contract_end_date === '')
                                    ">New end date is required</span>
                                    <span class="text-danger" v-if="
                                      apiErrors &&
                                      apiErrors['supplier_new_contract_end_date'] &&
                                      apiErrors['supplier_new_contract_end_date'].length
                                    ">
                                      {{ apiErrors["supplier_new_contract_end_date"][0] }}
                                    </span> -->
                                  </div>
                                </div>
                                <div v-if="formData.u4b_status === 'live'" class="col-12">
                                  <div class="form-wrap">
                                    <label class="col-form-label">Subsequent Renewal Status</label>
                                    <Field as="select" name="subsequent_renewal_status" class="form-select"
                                      v-model="formData.subsequent_renewal_status">
                                      <option value="">-----Select-----</option>
                                      <option v-for="res in (contractOptions.subsequent_renewal_status || [])"
                                        :key="res.value" :value="res.value">
                                        {{ res.text }}
                                      </option>
                                    </Field>
                                  </div>
                                </div>
                                <div v-if="formData.u4b_status === 'live'" class="col-12">
                                  <div class="form-wrap">
                                    <label class="col-form-label">Subsequent Renewal Responsible</label>
                                    <Field as="select" name="subsequent_renewal_responsible" class="form-select"
                                      v-model="formData.subsequent_renewal_responsible">
                                      <option value="">-----Select-----</option>
                                      <option v-for="res in saleResponsibleOptions" :key="res.id" :value="res.id">
                                        {{ res.name }}
                                      </option>
                                    </Field>
                                  </div>
                                </div>
                                <div v-if="formData.u4b_status === 'live'" class="col-12">
                                  <div class="form-wrap">
                                    <label class="col-form-label">Subsequent Renewal Opportunity Number</label>
                                    <Field as="input" type="text" name="subsequent_renewal_opportunity_number"
                                      class="form-control" v-model="formData.subsequent_renewal_opportunity_number" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row  mt-4">
                      <div class="col-md-4">
                        <div class="form-wrap mb-0" style="border: 1px solid #e1e1e1;">
                          <h4 class="p-2">Logs</h4>
                          <p class="col-form-label p-2" style="background-color: #eff1f0;">Add log entry</p>
                          <textarea class="form-control" rows="3" v-model="formData.content"></textarea>
                        </div>
                        <div class="row my-3">
                          <div class="col-md-12">
                            <div class="form-wrap mb-0 shadow resizable" style="border: 1px solid #e1e1e1;">
                              <p class="col-form-label p-2 log-head">Logs</p>
                              <div class="row" v-for="log in logs">
                                <div class="col-12">
                                  <p class="p-2" style="border-bottom: 1px solid #e1e1e1;white-space: pre-wrap;">{{
                                    log.content }}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-wrap mb-0 shadow" style="border: 1px solid #e1e1e1">
                              <h4 class="p-2">
                                Documents
                              </h4>
                              <div>
                                <div class="row">
                                  <div class="col-12">
                                    <div class="dropzone-container" @dragover="dragover" @dragleave="dragleave"
                                      @drop="drop">
                                      <input type="file" multiple name="file" id="fileInput" class="hidden-input"
                                        @change="onChange" ref="fileInput" />

                                      <label for="fileInput" class="file-label">
                                        <div v-if="isDragging">Release to drop files here.</div>
                                        <div v-else>Choose a file or drop it here</div>
                                        <p style="font-size: 10px;">
                                          The file must be a type of : pdf, doc, docx, png, jpeg, jpg, mp3, mp4, flac,
                                          wav.
                                        </p>
                                      </label>
                                    </div>
                                    <div class="table-responsive add-x-scroll">
                                      <table class="table table-bordered logs_Section">
                                        <tbody>
                                          <tr v-for="file in displayedFiles" :key="file.id">
                                            <td>
                                              <a :href="file.file_path" target="_blank" @click="downloadFile(file)">
                                                <i class="ti ti-download icon-size"></i>
                                              </a>
                                            </td>
                                            <td>
                                              <i class="ti ti-x icon-size" @click="deleteFile(file.id)"
                                                style="color: red;"></i>
                                            </td>
                                            <!-- <td class="truncate-doc-name">
                                              <a href="#" @click="viewFile(file.file_path)" :title="file.doc_name">
                                                {{ file.doc_name.length > 20 ? file.doc_name.substr(0, 15) + "...." :
                                                  file.doc_name }}
                                              </a>
                                            </td> -->

                                            <td class="truncate-doc-name" v-if="!renameStates[file.id]">
                                          <a href="#" @click="viewFile(file.file_path)" :title="file.doc_name">
                                            {{ file.doc_name.length > 20 ? file.doc_name.substr(0, 15) + '....' :
                                              file.doc_name }}
                                          </a>
                                          <span class="ms-2 cursor-pointer" title="Rename" style="font-size: 16px;"
                                            @click="showRenameField(file.doc_name, file.id)">
                                            <i class="ti ti-edit"></i>
                                          </span>
                                        </td>
                                        
                                        <td class="truncate-doc-name" v-if="renameStates[file.id]">
                                          <input type="text" class="border-0 border-bottom ms-2"
                                            v-model="renameInputs[file.id]">
                                          <span class="mx-2 cursor-pointer" @click="cancelRename(file.id)">
                                            <i class="ti-close"></i>
                                          </span>
                                          <span v-if="renameInputs[file.id]" class="me-2 cursor-pointer"
                                            @click="renameDoc(file.id, file.doc_type)">
                                            <i class="ti ti-check" style="font-size: 18px;"></i>
                                          </span>
                                        </td>

                                            <td class="d-flex flex-column align-items-center">
                                              <span>{{ formatDate(file.created_at) }}</span>
                                              <span>{{ file.file_size + file.file_size_unit }}</span>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                  <div v-if="fileData.length > 4" class="col-12">
                                    <p class="p-2" @click="toggleViewMore" style="cursor: pointer; color: blue;">
                                      {{ showAllFiles ? "View less ..." : "View more ..." }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="submit-button text-end mt-4">
                      <button type="button" class="btn btn-light" @click="handleCancel">
                        Cancel
                      </button>
                      <button type="submit" class="btn btn-primary">
                        Save
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-else-if="showFallback">
    <div class="col-md-12">
      <no-data-found />
    </div>
  </div>
  <div ref="closeLostModal" class="modal fade" id="confirm_modal" tabindex="-1" role="dialog"
    aria-labelledby="closeLostModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="d-flex justify-content-between">
          <h4 class="">Lost contract</h4>
          <div class="modal-header border-0 m-0 justify-content-end">
            <button class="btn-close" id="close-btn" data-bs-dismiss="modal" aria-label="Close" @click="cancel_change">
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
        <div class="modal-body confirm">
          <div class="col-md-12">
            <div class="form-wrap">
              <label class="col-form-label">Reason</label>
              <Field as="select" name="reason" class="form-select" v-model="formData.contract_closed_reason">
                <option value="">-----Select-----</option>
                <option v-for="res in contractOptions.con_closed_reason" :key="res.value" :value="res.value">
                  {{ res.text }}
                </option>
              </Field>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button class="btn btn-primary confirm-btn me-2" @click="confirm_change">
              Confirm
            </button>
            <button class="btn btn-outline-secondary cancel-btn" @click="cancel_change">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div ref="resellContract" class="modal fade" id="confirm_resell_modal" tabindex="-1" role="dialog"
    aria-labelledby="resellContractLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="d-flex justify-content-between">
          <h4 class="">RESELL is being created</h4>
          <div class="modal-header border-0 m-0 justify-content-end">
            <button class="btn-close" id="close-resell-btn" data-bs-dismiss="modal" aria-label="Close"
              @click="cancelResellChange">
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
        <div class="modal-body confirm">
          <!-- <p>Can remove data filters and displayed data</p> -->
          <div class="col-md-12">
            <div class="form-wrap">
              <label class="col-form-label">Reason</label>
              <Field as="select" name="cancelled_contract_reason" class="form-select"
                v-model="cancelledContractForm.cancelledContractReason"
                @change="onCancelledContractReasonChange">
                <option value="">-----Select-----</option>
                <option v-for="res in resellCancelledReasonOptions" :key="res.value" :value="res.value">
                  {{ res.text }}
                </option>
              </Field>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-wrap">
              <label class="col-form-label">Sub Reason</label>
              <Field as="select" name="cancelled_contract_reason_subtype" class="form-select"
                v-model="cancelledContractForm.cancelledContractReasonSubtype">
                <option value="">-----Select-----</option>
                <option v-for="res in resellCancelledReasonSubtypeOptions" :key="res.value" :value="res.value">
                  {{ res.text }}
                </option>
              </Field>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-wrap">
              <label class="col-form-label">Comment </label>
              <textarea class="form-control" rows="4" v-model="cancelledContractForm.comment"></textarea>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button class="btn btn-primary confirm-btn me-2" @click="confirmResellChange">
              Confirm
            </button>
            <button class="btn btn-outline-secondary cancel-btn" @click="cancelResellChange">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div ref="deadContract" class="modal fade" id="confirm_dead_modal" tabindex="-1" role="dialog"
    aria-labelledby="deadContractLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="d-flex justify-content-between">
          <h4 class="">Contract is being cancelled as Dead</h4>
          <div class="modal-header border-0 m-0 justify-content-end">
            <button class="btn-close" id="close-dead-btn" data-bs-dismiss="modal" aria-label="Close"
              @click="cancelDeadChange">
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
        <div class="modal-body confirm">
          <div class="col-md-12">
            <div class="form-wrap">
              <label class="col-form-label">Reason</label>
              <Field as="select" name="cancelled_contract_reason_dead" class="form-select"
                v-model="cancelledContractForm.cancelledContractReason"
                @change="onCancelledContractReasonChange">
                <option value="">-----Select-----</option>
                <option v-for="res in deadCancelledReasonOptions" :key="res.value" :value="res.value">
                  {{ res.text }}
                </option>
              </Field>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-wrap">
              <label class="col-form-label">Sub Reason</label>
              <Field as="select" name="cancelled_contract_reason_subtype_dead" class="form-select"
                v-model="cancelledContractForm.cancelledContractReasonSubtype">
                <option value="">-----Select-----</option>
                <option v-for="res in deadCancelledReasonSubtypeOptions" :key="res.value" :value="res.value">
                  {{ res.text }}
                </option>
              </Field>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-wrap">
              <label class="col-form-label">Comment</label>
              <textarea class="form-control" rows="4" v-model="cancelledContractForm.comment"></textarea>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button class="btn btn-primary confirm-btn me-2" @click="confirmDeadChange">
              Confirm
            </button>
            <button class="btn btn-outline-secondary cancel-btn" @click="cancelDeadChange">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div ref="liveContract" class="modal fade" id="confirm_live_modal" tabindex="-1" role="dialog"
    aria-labelledby="liveContractLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="d-flex justify-content-between">
          <h4 class="">Live is being created</h4>
          <div class="modal-header border-0 m-0 justify-content-end">
            <button class="btn-close" id="close-live-btn" data-bs-dismiss="modal" aria-label="Close"
              @click="cancelLiveChange">
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
        <div class="modal-body confirm">
          <!-- <p>Can remove data filters and displayed data</p> -->
          <div class="col-md-12">
            <div class="form-wrap">
              <label class="col-form-label">Term <span class="text-danger" v-if="
                isNotValid && (formData.opportunity.term === null || formData.opportunity.term === '')
              ">*</span></label>
              <Field name="term" as="input" type="text" class="form-control"
                :class="{ 'disable': user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible' }"
                v-model="formData.opportunity.term"
                :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'" />
              <span class="text-danger" v-if="
                isNotValid && (formData.opportunity.term === null || formData.opportunity.term === '')
              ">Term is required</span>
            </div>
          </div>
          <div class="col-12">
            <div class="form-wrap">
              <label class="col-form-label">Actual Start Date <span class="text-danger" v-if="
                isNotValid && (formData.supplier_contract_start_date === null || formData.supplier_contract_start_date === '')
              ">*</span></label>
              <div class="icon-form">
                <date-time-picker
                  v-model="formData.supplier_contract_start_date"
                  text-input
                  format="dd/MM/yyyy"
                  auto-apply
                  :enable-time-picker="false"
                  :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'"
                  :clearable="user.roles[0] === 'company_admin' || user.roles[0] === 'cm_responsible'"
                />
              </div>
              <span class="text-danger" v-if="
                isNotValid && (formData.supplier_contract_start_date === null || formData.supplier_contract_start_date === '')
              ">Actual start date is required</span>
            </div>
          </div>
          <div class="col-12">
            <div class="form-wrap">
              <label class="col-form-label">New End Date <span class="text-danger" v-if="
                isNotValid && (formData.supplier_new_contract_end_date === null || formData.supplier_new_contract_end_date === '')
              ">*</span></label>
              <div class="icon-form">
                <date-time-picker
                  v-model="formData.supplier_new_contract_end_date"
                  text-input
                  format="dd/MM/yyyy"
                  auto-apply
                  :enable-time-picker="false"
                  :disabled="user.roles[0] !== 'company_admin' && user.roles[0] !== 'cm_responsible'"
                  :clearable="user.roles[0] === 'company_admin' || user.roles[0] === 'cm_responsible'"
                />
              </div>
              <span class="text-danger" v-if="
                isNotValid && (formData.supplier_new_contract_end_date === null || formData.supplier_new_contract_end_date === '')
              ">New end date is required</span>
              <span class="text-danger" v-if="
                apiErrors &&
                apiErrors['supplier_new_contract_end_date'] &&
                apiErrors['supplier_new_contract_end_date'].length
              ">
                {{ apiErrors["supplier_new_contract_end_date"][0] }}
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button class="btn btn-primary confirm-btn me-2" @click="confirmLiveChange">
              Confirm
            </button>
            <button class="btn btn-outline-secondary cancel-btn" @click="cancelLiveChange">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

    <!-- <leave-confirmation-modal
    :show="showLeaveModal"
    @confirm="confirmLeave"
    @cancel="cancelLeave"
    /> -->

</template>

<script>
import {
  ref,
  onMounted,
  watch,
  computed,
  nextTick,
  onBeforeUnmount,
  onUnmounted
} from "vue";
import {
  useStore
} from "vuex";
import {
  useRouter,
  useRoute,
  onBeforeRouteLeave
} from "vue-router";
import {
  Form,
  Field,
  ErrorMessage
} from "vee-validate";
import * as Yup from "yup";
import { changeFormate } from '../../../../util'
import { message } from "ant-design-vue";
import apiClient from "@/axios";
import { Modal } from "bootstrap";
import isEqual from 'lodash.isequal';

const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
const currentDateTwo = ref(new Date());

export default {
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      startdate: currentDate,
      startdateOne: currentDateOne,
      startdateTwo: currentDateTwo,
      dateFormat: "dd/MM/yyyy",
      yesNoOptions: ["YES", "NO"],
    };
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const org_id = ref(null);
    const isEditable = ref(true);
    const isDateEditable = ref(true);
    const isShowWon = ref(false);
    const isLost = ref(false);
    const opportunityData = ref({});
    const companyType = ref(null)
    const isKanban = ref(false);
    const supplierOptions = ref([]);
    const terId = ref(null)
    const orgPersonsDetails = ref({})
    const orgId = ref(null)
    const apiErrors = ref([])
    const settingOptions = ref([])
    const isDragging = ref(false); // Reactive state for drag status
    const files = ref([]); // Reactive state for file storage
    const fileInput = ref(null); // Ref for file input element
    const fileData = ref([])
    const showFallback = ref(false)
    const showAllFiles = ref(false);
    const contractNumber = ref(route.params.id || null);
    const contractId = ref( null);
    const displayedFiles = computed(() => (showAllFiles.value ? fileData.value : fileData.value.slice(0, 4)));
    // const supplier_contract_start_date = ref();
    const selectedOption = ref()
    const isNotValid = ref(false);
    let billingAddress;

    const objectionValue = ref(0);
    const disabledObjection = ref(false)
    const rejectionValue = ref(0);
    const disabledRejection = ref(false)
    const last_objection_at = ref(null)
    const last_rejection_at = ref(null)
    let intervalId;

    const contactData = ref({})
    const resellContract = ref(null);
    const liveContract = ref(null);
    const closeLostModal = ref(null);
    const deadContract = ref(null);
    // const comment = ref("")

    const cancelledContractForm = ref({
      cancelledContractReason: "",
      cancelledContractReasonSubtype: "",
      comment: ""
    })

    const resetCancelledContractForm = (defaultReason = '') => {
      cancelledContractForm.value = {
        cancelledContractReason: defaultReason,
        cancelledContractReasonSubtype: '',
        comment: ''
      };
    };

    const onCancelledContractReasonChange = () => {
      nextTick(() => {
        cancelledContractForm.value.cancelledContractReasonSubtype = '';
      });
    };

    const getDefaultDeadReason = () => {
      const deadReason = getContractDropdownOptions(contractOptions.value.con_cancelled_contract_reasons)
        .find((option) => normalizeReasonKey(option.value) === 'dead');
      return deadReason?.value || 'Dead';
    };

    // const originalForm = ref({});
    // const hasUnsavedChanges = ref(false);
    // const showLeaveModal = ref(false);
    // let pendingRoute = null; // ✅ define this

    const showRename = ref(false)
    const renameInput = ref("")
    const fileId = ref("")

    const supplierName = computed(() => {
      const supplier = supplierOptions.value.find(item => item.id === formData.value.opportunity.new_supplier_id)
      return supplier?.text || null;
    })

    const toggleViewMore = () => {
      showAllFiles.value = !showAllFiles.value;
    };
    if (route.query.kanban) {
      isKanban.value = true;
    }
    const cmResponsibleOptions = computed(
      () => store.getters["opportunity/getCmResponsibles"]
    );
    const user = computed(() => store.getters['auth/user']);
    const pipelineLevels = ref([]);
    const options = computed(() => store.getters['opportunity/getoppDropdowns']);
    // const supplierOptions = computed(() => store.getters['opportunity/getoppSuppliers']);
    const contractOptions = computed(() => store.getters['contract/getcontractOptions']);
    const normalizeReasonKey = (value) => String(value || '').trim().toLowerCase();
    const DEFAULT_CANCELLED_CONTRACT_REASON_SUBTYPES = [
      { value: 'PreSub - De-Energised Meter', text: 'PreSub - De-Energised Meter', parent: 'PreSub' },
      { value: 'PreSub - Failed Credit', text: 'PreSub - Failed Credit', parent: 'PreSub' },
      { value: 'PreSub - Incorrect AQ', text: 'PreSub - Incorrect AQ', parent: 'PreSub' },
      { value: 'PreSub - Incorrect Price', text: 'PreSub - Incorrect Price', parent: 'PreSub' },
      { value: 'Rej - Failed Credit', text: 'Rej - Failed Credit', parent: 'Rejected' },
      { value: 'Rej - Incorrect Business Name', text: 'Rej - Incorrect Business Name', parent: 'Rejected' },
      { value: 'Rej - Unsupportable Meter', text: 'Rej - Unsupportable Meter', parent: 'Rejected' },
      { value: 'Obj - COT', text: 'Obj - COT', parent: 'Objected' },
      { value: 'Obj - Customer Agreed Direct', text: 'Obj - Customer Agreed Direct', parent: 'Objected' },
      { value: 'Obj - Debt', text: 'Obj - Debt', parent: 'Objected' },
      { value: 'Obj - Incorrect CED', text: 'Obj - Incorrect CED', parent: 'Objected' },
      { value: 'Dead - Business Closed Down', text: 'Dead - Business Closed Down', parent: 'Dead' },
      { value: 'Dead - Do Not Contact Again', text: 'Dead - Do Not Contact Again', parent: 'Dead' },
    ];
    const getContractDropdownOptions = (dropdown, fallback = []) => {
      if (!dropdown) {
        return fallback;
      }
      if (Array.isArray(dropdown)) {
        return dropdown.length ? dropdown : fallback;
      }
      if (Array.isArray(dropdown.options)) {
        return dropdown.options.length ? dropdown.options : fallback;
      }
      if (typeof dropdown === 'object') {
        const values = Object.values(dropdown).filter(
          (item) => item && typeof item === 'object' && item.value !== undefined
        );
        return values.length ? values : fallback;
      }
      return fallback;
    };
    const REASON_SUBTYPE_PREFIX_MAP = {
      presub: 'presub',
      'cm failed qa': 'presub',
      rejected: 'rej',
      objected: 'obj',
      dead: 'dead',
    };
    const getSubtypePrefixForReason = (reason) => {
      const normalizedReason = normalizeReasonKey(reason);
      return REASON_SUBTYPE_PREFIX_MAP[normalizedReason] || normalizedReason;
    };
    const getReasonSubtypeOptions = (subtypesDropdown, selectedReason) => {
      const subtypes = getContractDropdownOptions(
        subtypesDropdown,
        DEFAULT_CANCELLED_CONTRACT_REASON_SUBTYPES
      );
      if (!selectedReason || !subtypes.length) {
        return [];
      }

      const normalizedReason = normalizeReasonKey(selectedReason);
      const parentMatches = subtypes.filter(
        (option) => option.parent && normalizeReasonKey(option.parent) === normalizedReason
      );
      if (parentMatches.length) {
        return parentMatches;
      }

      const prefix = getSubtypePrefixForReason(selectedReason);
      return subtypes.filter((option) => {
        const value = normalizeReasonKey(option.value);
        return value.startsWith(`${prefix} -`) || value.startsWith(`${prefix}-`);
      });
    };
    const cancelledContractReasonOptions = computed(() =>
      getContractDropdownOptions(contractOptions.value.con_cancelled_contract_reasons)
    );
    const resellCancelledReasonOptions = computed(() =>
      cancelledContractReasonOptions.value.filter(
        (option) => normalizeReasonKey(option.value) !== 'dead'
      )
    );
    const deadCancelledReasonOptions = computed(() =>
      cancelledContractReasonOptions.value.filter(
        (option) => normalizeReasonKey(option.value) === 'dead'
      )
    );
    const resellCancelledReasonSubtypeOptions = computed(() => getReasonSubtypeOptions(
      contractOptions.value.con_cancelled_contract_reason_subtypes,
      cancelledContractForm.value.cancelledContractReason
    ));
    const deadCancelledReasonSubtypeOptions = computed(() => getReasonSubtypeOptions(
      contractOptions.value.con_cancelled_contract_reason_subtypes,
      cancelledContractForm.value.cancelledContractReason
    ));
    // const opportunityData = computed(() => store.getters['opportunity/getoppViewData']);
    const orgPersons = ref([]);

    // const saleResponsibleOptions = computed(() => store.getters['organisation/getfetchAssignedTo']);
    const saleResponsibleOptions = computed(() => store.getters["organisation/getresUsersOptions"]);

    // Computed property to format the date
    const formattedNextUpdateLatest = computed(() => {
      const date = new Date(formData.value.next_update_latest);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    });
    const formattedData = computed(() => {
      const {
        forecast_commission
      } = formData.value.opportunity;
      return {
        sc_forecast_or_amended_annual_consumption: (forecast_commission.sc_forecast_or_amended_annual_consumption),
        cancelled_commission: formatNumber(forecast_commission.cancelled_commission),
        sc_corecast_or_amended_total_commission: (forecast_commission.sc_corecast_or_amended_total_commission),
        sc_forecast_or_amended_first_payment: formatNumber(forecast_commission.sc_forecast_or_amended_first_payment),
        sc_forecast_or_amended_residual_payment: formatNumber(forecast_commission.sc_forecast_or_amended_residual_payment),
        u4b_uplift: formatNumber(forecast_commission.u4b_uplift),
        final_contract_consumption: formatNumber(forecast_commission.final_contract_consumption),
        failed_credit: formatNumber(forecast_commission.failed_credit),
        final_contract_commission: formatNumber(forecast_commission.final_contract_commission),
        actual_first_payment: formatNumber(forecast_commission.actual_first_payment),
        actual_residual_payment: formatNumber(forecast_commission.actual_residual_payment),
        forecast_first_payment_amount: formatNumber(forecast_commission.forecast_first_payment_amount),
        kva: formatNumber(forecast_commission.kva)
      };
    });
    // Watch for changes to formatted data and update the raw data
    const updateFormData = (key, value) => {
      formData.value.opportunity.forecast_commission[key] = removeFormatting(value);
    };

    const schema = Yup.object().shape({
      // revert_to_meter_opportunity: Yup.string()
      //   .required("Pipeline level is required"),
      quoted_annual_consumption: Yup.number()
        .typeError("SC Consumption must be a number"),
      sc_forecast_total_commission: Yup.number()
        .typeError("SC Commission must be a number"),
      // cm_date: Yup.date()
      //   .nullable() // allows null value
      //   .typeError("CM Date must be a valid date")
      //   .max(Yup.ref('contract_start_date'), 'CM Date cannot be greater than the start date'),
      u4b_unique_id: Yup
        .string()
        .nullable()
        .notRequired()
        .test(
          'u4b-format',
          'U4B Unique ID must start with U4B followed by 8 or 9 digits (e.g. U4B00000000)',
          value => {
            if (!value) return true
            return /^U4B\d{8,9}$/.test(value)
          }
        )
    });
    // const isEditing = ref(false);
    // if (route.query.org_Id) {
    //   org_id.value = route.query.org_Id;
    //   isEditing.value = true;
    // }
    const formData = ref({
      id: null,
      contract_contact: null,
      contract_description: "",
      contract_number: "",
      contract_responsible: null,
      content: '',
      cm_date: null,
      submitted_via: '',
      term_cot: null,
      term_status: '',
      cot_status: null,
      term_cot_followup_date: null,
      submission_id: '',
      u4b_status_changed_at: null,
      contract_closed_reason: '',
      u4b_unique_id:'',
      wp_sent: false,
      opportunity: {
        id: null,
        opp_type: null,
        term: null,
        consumption_source: null,
        waste_consumption: null,
        water_consumption: null,
        contract_end_date: null,
        contract_start_date: null,
        cot: null,
        cot_date: null,
        date_of_sale: null,
        comment: '',
        new_supplier_id: null,
        description: "",
        main_production_service: null,
        meter_opportunity_nr_auto: null,
        mpr: null,
        mpan_top: null,
        mpan_bottom: null,
        nic: null,
        organization_id: null,
        quotation: "",
        quoted_annual_consumption: 0.00,
        referred_by: null,
        sale_type: null,
        sales_responsible: null,
        sc_forecast_total_commission: 0.00,
        spid: null,
        supplier_id: null,
        cm_responsible: null,
        quotes: {
          id: '',
          standing_charge: null,
          day_unit_rate: null,
          night_unit_rate: null,
          evening_and_weekend: null,
        },
        forecast_commission: {
          sc_forecast_or_amended_annual_consumption: 0.00,
          final_contract_consumption: 0.00,
          cancelled_commission: 0.00,
          failed_credit: 0.00,
          sc_corecast_or_amended_total_commission: 0.00,
          final_contract_commission: 0.00,
          sc_forecast_or_amended_first_payment: 0.00,
          actual_first_payment: 0.00,
          sc_forecast_or_amended_residual_payment: 0.00,
          actual_residual_payment: 0.00,
          u4b_uplift: 0.00,
          forecast_first_payment_amount: 0.00,
          kva: 0.00,
          day_consumption: null,
          day_uplift: null,
          night_consumption: null,
          night_uplift: null,
          weekend_consumption: null,
          weekend_uplift: null,
          uplift_standing_charge: null,
        },
        supply_address: {
          building_name: '', //string input
          street: '', //string input
          city: '', //string input
          county: '', //string input
          postcode: '', //string input
        },
        billing_address: {
          address_line_1: "",
          address_line_2: "",
          address_line_3: "",
          address_line_4: "",
          postcode: "",
        },
        billing_address_same_as: ""
      },
      // overall_risk: null,
      // overall_status: "",
      revert_to_meter_opportunity: null,
      supplier_actual_first_payment_date: null,
      supplier_actual_residual_payment_date: null,
      supplier_contract_start_date: null,
      supplier_forecast_first_payment_date: null,
      supplier_forecast_residual_payment_date: null,
      supplier_forecast_second_payment_date: null,
      supplier_forecast_third_payment_date: null,
      supplier_new_contract_end_date: null,
      department_to_resolve: null,
      u4b_status: null,
      termination_responsible: null,
      subsequent_renewal_status: null,
    });
    const TERM_STATUS_ALLOWED = ['Customer', 'U4B Termination', 'Terminated'];
    const COT_STATUS_ALLOWED = ['COT', 'COT Complete'];
    const isTermStatusEnterable = computed(() =>
      TERM_STATUS_ALLOWED.includes(formData.value.term_cot)
    );
    const isCotStatusEnterable = computed(() =>
      COT_STATUS_ALLOWED.includes(formData.value.term_cot)
    );
    const onTermCotChange = () => {
      if (!isTermStatusEnterable.value) {
        formData.value.term_status = '';
      }
      if (!isCotStatusEnterable.value) {
        formData.value.cot_status = null;
      }
    };
    const logs = ref([]);

    const org_details = ref({});
    const complete_address = ref('');
    const addDays = ref(['0', '1', '4', '5', '6', '7', '14', '21']);
    const addMonths = ref(['1', '2', '3', '4', '5', '6', '9', '12']);
    const fetchContract = async (id) => {
      try {
        const data = await store.dispatch('contract/fetchContractData', id);
          if(!data){
                    showFallback.value = true;
                    return
                }
        contactData.value = { ...data };
        orgId.value = data.organization_id;
        terId.value = data.territory_id;
        contractId.value = data.id;

        complete_address.value = data.complete_address;
        opportunityData.value = { ...data.opportunity };
        org_details.value = data.opportunity.organization;
        companyType.value = data.opportunity.organization.type;
        orgPersonsDetails.value = data.contract_contact_person;
        billingAddress = { ...data.opportunity.billing_address };
        formData.value.opportunity.billing_address_same_as = data.opportunity.billing_address_same_as;
        selectedOption.value = data.opportunity.billing_address_same_as;
        objectionValue.value = data.number_of_objection;
        rejectionValue.value = data.number_of_rejection;
        last_objection_at.value = data.last_objection_at;
        last_rejection_at.value = data.last_rejection_at;
        logs.value = data.contract_logs;
        Object.assign(formData.value, data);
        formData.value.wp_sent = Boolean(data.wp_sent);
        Object.assign(formData.value.opportunity, data.opportunity);
        Object.assign(formData.value.opportunity.forecast_commission, data.opportunity.forecast_commission);
        Object.assign(formData.value.opportunity.supply_address, data.opportunity.supply_address);
        if (data.u4b_status_changed_at) {
          formData.value.u4b_status_changed_at = new Date(data.u4b_status_changed_at)
        }
        if (data.opportunity.date_of_sale) {
          formData.value.opportunity.date_of_sale = new Date(data.opportunity.date_of_sale);
        }
        if (data.cm_date) {
          formData.value.cm_date = new Date(data.cm_date);
        }
        if (data.term_cot_followup_date) {
          formData.value.term_cot_followup_date = new Date(data.term_cot_followup_date);
        }
        if (data.opportunity.contract_end_date) {
          formData.value.opportunity.contract_end_date = new Date(data.opportunity.contract_end_date);
        }
        if (data.opportunity.cot_date) {
          formData.value.opportunity.cot_date = new Date(data.opportunity.cot_date);
        }
        if (data.opportunity.contract_start_date) {
          formData.value.opportunity.contract_start_date = new Date(data.opportunity.contract_start_date);
        }
        // Add the new date variables with the `changeFormate` function
        if (data.supplier_actual_first_payment_date) {
          formData.value.supplier_actual_first_payment_date = new Date(data.supplier_actual_first_payment_date);
        }
        if (data.supplier_actual_residual_payment_date) {
          formData.value.supplier_actual_residual_payment_date = new Date(data.supplier_actual_residual_payment_date);
        }
        if (data.supplier_contract_start_date) {
          formData.value.supplier_contract_start_date = new Date(data.supplier_contract_start_date);
        }
        // supplier_contract_start_date.value = data.supplier_contract_start_date;
        if (data.supplier_forecast_first_payment_date) {
          formData.value.supplier_forecast_first_payment_date = new Date(data.supplier_forecast_first_payment_date);
        }
        if (data.supplier_forecast_residual_payment_date) {
          formData.value.supplier_forecast_residual_payment_date = new Date(data.supplier_forecast_residual_payment_date);
        }
        if (data.supplier_forecast_second_payment_date) {
          formData.value.supplier_forecast_second_payment_date = new Date(data.supplier_forecast_second_payment_date);
        }
        if (data.supplier_forecast_third_payment_date) {
          formData.value.supplier_forecast_third_payment_date = new Date(data.supplier_forecast_third_payment_date);
        }
        if (data.supplier_new_contract_end_date) {
          formData.value.supplier_new_contract_end_date = new Date(data.supplier_new_contract_end_date);
        }

        formData.value.content = ''
        fileData.value = data.contract_docs;
        // originalForm.value = structuredClone(formData.value);
      } catch (error) {
        console.error('Error fetching organization data:', error);
      }
    };
    const fetchOrgPerson = async (id) => {
      const totalPersons = await store.dispatch("opportunity/fetchPersons", id);
      orgPersons.value = totalPersons;
      // if(orgPersons.value.length === 1 ){
      //   formData.value.opportunity.sales_contact = orgPersons.value[0].id;
      //   formData.value.contract_contact = orgPersons.value[0].id;
      // }
    }
    const myChangeEvent = (event, role) => {
      if (event.id === 'null') {
        if (role === 'current') {
          formData.value.opportunity.supplier_id = null;
        } else if (role === 'new') {
          formData.value.opportunity.new_supplier_id = null;
        }
      }
    }

    const selectOption = (option) => {
      // Toggle the option or uncheck if already selected
      selectedOption.value = selectedOption.value === option ? null : option;
      formData.value.opportunity.billing_address_same_as = selectedOption.value;
      if (selectedOption.value === 'supply') {
        formData.value.opportunity.billing_address.address_line_1 = formData.value.opportunity.supply_address.building_name;
        formData.value.opportunity.billing_address.address_line_2 = formData.value.opportunity.supply_address.street;
        formData.value.opportunity.billing_address.address_line_3 = formData.value.opportunity.supply_address.city;
        formData.value.opportunity.billing_address.address_line_4 = formData.value.opportunity.supply_address.county;
        formData.value.opportunity.billing_address.postcode = formData.value.opportunity.supply_address.postcode;
      } else if (selectedOption.value === 'organisation') {
        formData.value.opportunity.billing_address.address_line_1 = org_details.value.address;
        formData.value.opportunity.billing_address.address_line_2 = org_details.value.city;
        formData.value.opportunity.billing_address.address_line_3 = org_details.value.state;
        formData.value.opportunity.billing_address.address_line_4 = org_details.value.address_line_4;
        formData.value.opportunity.billing_address.postcode = org_details.value.postcode;
      }
      else {
        formData.value.opportunity.billing_address.address_line_1 = billingAddress.address_line_1;
        formData.value.opportunity.billing_address.address_line_2 = billingAddress.address_line_2;
        formData.value.opportunity.billing_address.address_line_3 = billingAddress.address_line_3;
        formData.value.opportunity.billing_address.address_line_4 = billingAddress.address_line_4;
        formData.value.opportunity.billing_address.postcode = billingAddress.postcode;
      }
    }

    const handleChange = () => {
      formData.value.opportunity.billing_address_same_as = "";
      selectedOption.value = ""
    }

    // Utility functions for formatting and removing formatting
    const formatNumber = (value) => {
      const number = parseFloat(value);
      if (!isNaN(number)) {
        return number.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
      return '0.00';
    };
    const fetchOptions = async () => {
      try {
        const response = await apiClient.get("settings/organisation-person");
        settingOptions.value = response.data.data.dropdowns;
      } catch (error) {
        console.error("Error fetching options data:", error);
      }
    };
    const removeFormatting = (value) => {
      const numberValue = value.replace(/,/g, ''); // Remove commas
      return parseFloat(numberValue) || 0;
    };
    // Function to add days or months
    const addToDate = (field, type, value) => {
      // Check if the field is valid
      if (['date_of_sale', 'next_update_latest'].includes(field)) {
        const numericValue = parseInt(value); // Convert the string value to an integer

        // If value is 0, set the date to today's date
        if (numericValue === 0) {
          formData.value[field] = new Date(); // Set to today's date
        } else {
          // Get the current date for the field (or today's date if the field is not set)
          const currentDate = new Date(formData.value[field] || new Date());

          // Add days or months based on the type
          if (type === 'days') {
            currentDate.setDate(currentDate.getDate() + numericValue); // Add days
          } else if (type === 'months') {
            currentDate.setMonth(currentDate.getMonth() + numericValue); // Add months
          }

          // Update the corresponding field in formData
          formData.value[field] = new Date(currentDate);
        }
      }
    };
     const handleEmailClick = (email) => {
      // Open email client
      window.location.href = `mailto:${email}`;

      // OR do something custom like showing a modal, copying, etc.
    };
    const closeLost = () => {
      // In Firefox, v-model may not have updated yet when @change fires. Use nextTick so we always read the current value.
      nextTick(() => {
        const status = formData.value.u4b_status;
        if (status === 'closed lost') {
          formData.value.contract_closed_reason = contactData.value.contract_closed_reason;
          const modal = new Modal(document.getElementById("confirm_modal"));
          modal.show();
        }

        if (status === 'cancelled resell') {
          resetCancelledContractForm();
          const modal = new Modal(document.getElementById("confirm_resell_modal"));
          modal.show();
        }

        if (status === 'cancelled dead') {
          resetCancelledContractForm(getDefaultDeadReason());
          const modal = new Modal(document.getElementById("confirm_dead_modal"));
          modal.show();
        }

        if (status === 'live') {
          isNotValid.value = false;
          const modal = new Modal(document.getElementById("confirm_live_modal"));
          modal.show();
        }
      });
    };
    const confirm_change = async () => {
      updateContract()
      // document.getElementById("close-btn").click();
    };
    const cancel_change = async () => {
      formData.value.u4b_status = contactData.value.u4b_status;
      document.getElementById("close-btn").click();
    };

    const confirmResellChange = async () => {
      const data = {
        u4bStatus: formData.value.u4b_status,
        cancelledContractReason: cancelledContractForm.value.cancelledContractReason,
        cancelledContractReasonSubtype: cancelledContractForm.value.cancelledContractReasonSubtype,
        comment: cancelledContractForm.value.comment
      }
      const form = {
        // oppId: route.query.contract_Id,
        oppId: contractId.value,
        payload: data
      }
      const response = await store.dispatch('contract/duplicateMeterOpp', form);
      if (response?.status) {
        document.getElementById("close-resell-btn").click();
        router.push({
          path: `/crm/meter-opportunities-edit/${response.data?.opportunity_id}`
          // query: {
          //   territory_id: response.data?.territory_id,
          //   org_Id: response.data?.organization_id,
          //   opp_Id: response.data?.opportunity_id
          // }
        });
      }
    }

    const cancelResellChange = () => {
      formData.value.u4b_status = contactData.value.u4b_status;
      document.getElementById("close-resell-btn").click();
    }

    const confirmDeadChange = async () => {
      const data = {
        cancelledContractReason: cancelledContractForm.value.cancelledContractReason,
        cancelledContractReasonSubtype: cancelledContractForm.value.cancelledContractReasonSubtype,
        comment: cancelledContractForm.value.comment
      };
      const form = {
        contractId: contractId.value,
        payload: data
      };
      const response = await store.dispatch('contract/cancelContractDead', form);
      if (response?.status) {
        document.getElementById("close-dead-btn").click();
        await fetchContract(contractId.value);
      }
    };

    const cancelDeadChange = () => {
      formData.value.u4b_status = contactData.value.u4b_status;
      document.getElementById("close-dead-btn").click();
    };

    const cancelDeadOnHidden = () => {
      formData.value.u4b_status = contactData.value.u4b_status;
    };

    const cancelLiveChange = () => {
      formData.value.u4b_status = contactData.value.u4b_status;
      formData.value.supplier_contract_start_date = contactData.value.supplier_contract_start_date ? new Date(contactData.value.supplier_contract_start_date) : null;
      formData.value.supplier_new_contract_end_date = contactData.value.supplier_new_contract_end_date ? new Date(contactData.value.supplier_new_contract_end_date) : null;
      formData.value.opportunity.term = opportunityData.value.term;

      document.getElementById("close-live-btn").click();
    }

    const confirmLiveChange = async () => {
      await updateContract();
      // document.getElementById("close-live-btn").click();
    }

    const updateContract = async () => {
      if (formData.value.u4b_status === 'live' &&
        (formData.value.supplier_contract_start_date === '' || formData.value.supplier_new_contract_end_date === '' || formData.value.opportunity.term === 'null' || formData.value.supplier_contract_start_date === null || formData.value.supplier_new_contract_end_date === null || formData.value.opportunity.term === null)) {
        isNotValid.value = true;
        return;
      } else {
        isNotValid.value = false;
        const date_of_sale = changeFormate(formData.value.opportunity.date_of_sale)
        const cm_date = changeFormate(formData.value.cm_date)
        const contract_end_date = changeFormate(formData.value.opportunity.contract_end_date)
        const contract_start_date = changeFormate(formData.value.opportunity.contract_start_date)
        const cot_date = changeFormate(formData.value.opportunity.cot_date)
        const supplier_actual_first_payment_date = changeFormate(formData.value.supplier_actual_first_payment_date)
        const supplier_actual_residual_payment_date = changeFormate(formData.value.supplier_actual_residual_payment_date)
        const supplier_contract_start_date = changeFormate(formData.value.supplier_contract_start_date)
        const supplier_forecast_first_payment_date = changeFormate(formData.value.supplier_forecast_first_payment_date)
        const supplier_forecast_residual_payment_date = changeFormate(formData.value.supplier_forecast_residual_payment_date)
        const supplier_forecast_second_payment_date = changeFormate(formData.value.supplier_forecast_second_payment_date)
        const supplier_forecast_third_payment_date = changeFormate(formData.value.supplier_forecast_third_payment_date)
        const supplier_new_contract_end_date = changeFormate(formData.value.supplier_new_contract_end_date)
        const term_cot_followup_date = changeFormate(formData.value.term_cot_followup_date)
        const response = await store.dispatch('contract/updateContract', {
          ...formData.value,
          supplier_actual_first_payment_date: supplier_actual_first_payment_date,
          supplier_actual_residual_payment_date: supplier_actual_residual_payment_date,
          supplier_contract_start_date: supplier_contract_start_date,
          supplier_forecast_first_payment_date: supplier_forecast_first_payment_date,
          supplier_forecast_residual_payment_date: supplier_forecast_residual_payment_date,
          supplier_forecast_second_payment_date: supplier_forecast_second_payment_date,
          supplier_forecast_third_payment_date: supplier_forecast_third_payment_date,
          supplier_new_contract_end_date: supplier_new_contract_end_date,
          term_cot_followup_date: term_cot_followup_date,
          cm_date: cm_date,
          opportunity: {
            ...formData.value.opportunity,
            date_of_sale: date_of_sale,
            contract_end_date: contract_end_date,
            contract_start_date: contract_start_date,
            cot_date: cot_date,
          }
        });
        if (!response.status) {
          apiErrors.value = response.errors;
          message.error(response.message)
        }
        else {
          // showLeaveModal.value = false;
          // hasUnsavedChanges.value = false;
          apiErrors.value = [];
          if ((formData.value.revert_to_meter_opportunity || formData.value.u4b_status === 'live') && response.data.u4b_status_changed == true) {
            // const id = formData.value.revert_to_meter_opportunity;
            // const result = pipelineLevels.value.find(item => item.id === id);
            // if (result.name !== 'Closed Meter Op') {
            // }  

            if (!formData.value.revert_to_meter_opportunity && formData.value.u4b_status === 'live') {
              await fetchContract(contractId.value);
            }
            document.getElementById("close-live-btn").click();
            const url = router.resolve({
              path: `/crm/meter-opportunities-edit/${response.data?.new_opportunity_id}`
              // query: {
              //   org_Id: response?.data?.organization_id,
              //   ter_Id: response?.data?.territory_id,
              //   opp_Id: response?.data?.new_opportunity_id
              // }
            }).href;

            window.open(url, "_blank");
          }
          else {
            message.success('Contract saved successfully');
            document.getElementById("close-btn").click();
            await fetchContract(contractId.value);
          }
          // await fetchContract(contractId.value);
          // handleCancel();
        }
      }
    };
    const fetchPipelineData = async () => {
      const data = await store.dispatch('opportunity/fetchPipelines');
      const filteredPipelineLevels = data.filter(level => level.name !== "Contract - won");
      pipelineLevels.value = filteredPipelineLevels;
    }
    const handleCancel = async () => {
      const query = route.query.add;
      if (query === "org-details") {
        router.push({
          path: "/crm/organisation-details",
          query: {
            org_Id: orgId.value,
            ter_Id: terId.value,
            contract_Id: contractId.value,
            for: 'contracts'
          },
        });
      } else {
        router.push("/crm/contracts-list");
      }
    };
    const onChange = async () => {
      if (fileInput.value && fileInput.value.files) {
        files.value = fileInput.value.files;
        const response = await store.dispatch("opportunity/uploadFile", {
          type: 'contract',
          file: files.value,
          id: contractId.value
        });
        if (response.status) {
          await fetchContract(contractId.value)
        }
      }
    };

    const dragover = (e) => {
      e.preventDefault();
      isDragging.value = true;
    };

    const dragleave = () => {
      isDragging.value = false;
    };

    const drop = (e) => {
      e.preventDefault();
      if (fileInput.value) {
        fileInput.value.files = e.dataTransfer.files;
        onChange();
      }
      isDragging.value = false;
    };

    const deleteFile = async (id) => {
      const response = await store.dispatch("opportunity/deleteFile", id)
      if (response.status) {
        // const opp_Id = route.query.opp_Id;
        await fetchContract(contractId.value)
      }
    }

        // State tracking
        const renameStates = ref({})
    const renameInputs = ref({})

    // Methods
    const showRenameField = (docName, fileId) => {
      renameStates.value[fileId] = true
      renameInputs.value[fileId] = docName
    }

    const cancelRename = (fileId) => {
      renameStates.value[fileId] = false
    }

    const renameDoc = async(fileId, doc_type) => {
      const newName = renameInputs.value[fileId]
      if (newName) {
          const payload = {
            doc_id: fileId,
            // doc_name: `${newName}.${doc_type}`
             doc_name: newName
          }
          const response = await store.dispatch("opportunity/renameFile", payload)
          if (response.status) {
            await fetchContract(contractId.value);
            renameStates.value[fileId] = false
          }
      }
    }


    const viewFile = (url) => {
      const link = document.createElement('a');
      link.href = url;
      link.download = url.split('/').pop();
      link.target = '_blank';
      link.click();
    };

    const downloadFile = async (file) => {

      await store.dispatch("opportunity/downloadFile", file)

    };
    const formatDate = (date) => {
      if (date) {
        const [year, month, day] = date.split('T')[0].split('-');
        return `${day}-${month}-${year}`;
      }
    };

    const clickOutside = () => {
      formData.value.u4b_status = contactData.value.u4b_status;
      formData.value.supplier_contract_start_date = contactData.value.supplier_contract_start_date ? new Date(contactData.value.supplier_contract_start_date) : null;
      formData.value.supplier_new_contract_end_date = contactData.value.supplier_new_contract_end_date ? new Date(contactData.value.supplier_new_contract_end_date) : null;
      formData.value.opportunity.term = opportunityData.value.term;
    };

    const cooldownTime = 2 * 60 * 60 * 1000;
    const checkCooldown = () => {
      // const currentTime = new Date().getTime()
      // const currentTime = new Date(new Date().toUTCString()).getTime() - 5.5 * 60 * 60 * 1000;
      const ukDate = new Date().toLocaleString("en-GB", { timeZone: "Europe/London" });
      const currentTime = new Date(ukDate.replace(/(\d+)\/(\d+)\/(\d+),/, "$3-$2-$1")).getTime();
      disabledObjection.value = currentTime - new Date(last_objection_at.value).getTime() > cooldownTime;
      disabledRejection.value = currentTime - new Date(last_rejection_at.value).getTime() > cooldownTime;
      if (disabledObjection.value && disabledRejection.value) {
        clearInterval(intervalId);
      }
    }

    const adjustObjection = async (amount, event) => {
      event.preventDefault(); // Prevent default behavior
      // const contract_Id = route.query.contract_Id;
      const payload = {
        data: {
          field: 'number_of_objection',
        },
        contract_Id: contractId.value
      }
      const response = await store.dispatch("contract/updateContractCounter", payload)
      if (response.status) {
        // await fetchContract(contractId.value);
        objectionValue.value += amount;
        clearInterval(intervalId);
        intervalId = setInterval(checkCooldown, 1000); // Run every second
      }
    };

    const adjustRejection = async (amount, event) => {
      event.preventDefault(); // Prevent default behavior
      // const contract_Id = route.query.contract_Id;
      const payload = {
        data: {
          field: 'number_of_rejection',
        },
        contract_Id: contractId.value
      }
      const response = await store.dispatch("contract/updateContractCounter", payload)
      if (response.status) {
        // await fetchContract(contractId.value);
        rejectionValue.value += amount;
        clearInterval(intervalId);
        intervalId = setInterval(checkCooldown, 1000); // Run every second
      }

    };


    const totalConsumption = () => {
      const night_consumption = parseInt(formData.value.opportunity.forecast_commission.night_consumption) || 0;
      const weekend_consumption = parseInt(formData.value.opportunity.forecast_commission.weekend_consumption) || 0;
      const day_consumption = parseInt(formData.value.opportunity.forecast_commission.day_consumption) || 0;

      // Ensure that we only consider the new values instead of accumulating over previous sums
      formData.value.opportunity.forecast_commission.sc_forecast_or_amended_annual_consumption =
        Number(night_consumption + weekend_consumption + day_consumption);
    };

    onMounted(() => {
      if (resellContract.value) {
        resellContract.value.addEventListener("hidden.bs.modal", clickOutside);
      }
      if (deadContract.value) {
        deadContract.value.addEventListener("hidden.bs.modal", cancelDeadOnHidden);
      }
      if (closeLostModal.value) {
        closeLostModal.value.addEventListener("hidden.bs.modal", clickOutside);
      }
      if (liveContract.value) {
        liveContract.value.addEventListener("hidden.bs.modal", clickOutside);
      }
    });
    onMounted(async () => {
      if (contractNumber.value) {
        await fetchContract(contractNumber.value);
        checkCooldown(); // Run initially
        intervalId = setInterval(checkCooldown, 1000); // Run every second
      }
      if (orgId.value) {
        await fetchOrgPerson(orgId.value);
      }
      // Execute metadata dropdown requests in parallel instead of sequentially
      const [, , , , , oppOptions] = await Promise.all([
        store.dispatch('contract/fetchContractOptions'),
        fetchOptions(),
        store.dispatch('auth/loadUserFromLocalStorage'),
        fetchPipelineData(),
        terId.value ? store.dispatch("organisation/fetchTerritoryCompanyUsers", terId.value) : Promise.resolve(),
        store.dispatch('opportunity/fetchOpportunityOptions'),
        terId.value ? store.dispatch("opportunity/fetchCMUsers", terId.value) : Promise.resolve()
      ]);

      if (oppOptions?.supplier) {
        supplierOptions.value = [
          { id: 'null', text: 'Search supplier....', original: null },
          ...oppOptions.supplier.map(item => ({
            id: item.id,
            text: item.name,
            original: item,
          }))
        ];
      }
    });

    watch(
      () => [route.query.contract_Id, route.params.id],
      async (newVal, oldVal) => {
        const contractId = route.query.contract_Id || route.params.id;
        // Only run fetchContract if route ID actually changed after initial mount
        if (contractId && oldVal && (newVal[0] !== oldVal[0] || newVal[1] !== oldVal[1])) {
          await fetchContract(contractId);
          checkCooldown();
        }
      }
    );

    onUnmounted(() => {
      clearInterval(intervalId);
    })

    // Router navigation guard
    // onBeforeRouteLeave((to, from, next) => {
    //   hasUnsavedChanges.value = !isEqual(originalForm.value, formData.value)
    //   if (hasUnsavedChanges.value) {
    //     showLeaveModal.value = true;
    //     pendingRoute = to;
    //     next(false);
    //   } else {
    //     next();
    //   }
    // });

    // const confirmLeave = () => {
    //   showLeaveModal.value = false;
    //   hasUnsavedChanges.value = false;
    //   formData.value = structuredClone(originalForm.value);
    //   if (pendingRoute) {
    //     router.push(pendingRoute); // Manually navigate
    //     pendingRoute = null;
    //   }
    // };

    // const cancelLeave = () => {
    //   showLeaveModal.value = false;
    //   pendingRoute = null;
    // };

    return {
      schema,
      formData,
      org_id,
      user,
      updateContract,
      contractId,
      myChangeEvent,
      handleCancel,
      pipelineLevels,
      cmResponsibleOptions,
      closeLost,
      options,
      supplierOptions,
      orgPersons,
      fetchOrgPerson,
      opportunityData,
      org_details,
      complete_address,
      // isEditing,
      saleResponsibleOptions,
      addDays,
      addMonths,
      addToDate,
      apiErrors,
      logs,
      formattedNextUpdateLatest,
      orgPersonsDetails,
      fetchPipelineData,
      // fetchWinProb,
      isEditable,
      isKanban,
      formattedData,
      formatNumber,
      updateFormData,
      isNotValid,
      removeFormatting,
      isDateEditable,
      formatDate,
      displayedFiles,
      toggleViewMore,
      companyType,
      isShowWon,
      isLost,
      contractOptions,
      isTermStatusEnterable,
      isCotStatusEnterable,
      onTermCotChange,
      onChange,
      dragover,
      dragleave,
      drop,
      fileData,
      isDragging,
      deleteFile,
      viewFile,
      fileInput,
      downloadFile,
      terId,
      showFallback,
      orgId,
      confirm_change,
      cancel_change,
      fetchOptions,
      settingOptions,
      selectedOption,
      handleChange,
      selectOption,
      confirmResellChange,
      cancelResellChange,
      confirmDeadChange,
      cancelDeadChange,
      cancelledContractForm,
      resellCancelledReasonOptions,
      resellCancelledReasonSubtypeOptions,
      deadCancelledReasonOptions,
      deadCancelledReasonSubtypeOptions,
      deadContract,
      contactData,
      clickOutside,
      resellContract,
      closeLostModal,
      // comment,
      contractNumber,
      liveContract,
      cancelLiveChange,
      confirmLiveChange,
      objectionValue,
      adjustObjection,
      disabledObjection,
      rejectionValue,
      adjustRejection,
      disabledRejection,
      checkCooldown,
      last_objection_at,
      last_rejection_at,
      supplierName,
      totalConsumption,
      showAllFiles,
      user,
      renameDoc,
      showRename,
      renameInput,
      showRenameField,
      fileId,
      cancelRename,
      renameStates,
      renameInputs,
      onCancelledContractReasonChange,
      handleEmailClick,
      // confirmLeave,
      // cancelLeave,
      // originalForm,
      // hasUnsavedChanges,
      // showLeaveModal
    };
  },
};
</script>

<style lang="scss" scoped>
.checkbox-size {
  transform: scale(1.5);
  /* Adjust the scale factor as needed */
  margin-right: 10px;
}

.contract-won-row {
  background-color: #5cb85c21;
}

.contract-lost-row {
  background-color: #ff00001a;
}

.website {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  background-color: #00918e;
  color: #fff;
}

.add-cursor {
  cursor: pointer;
  font-weight: 400;
}

.disabled {
  background-color: #F6F6F6;
}

.disable {
  background-color: #e9ecef !important;
}

.dropzone-container {
  text-align: center;
  padding: 1rem;
  margin: 1rem 5px;
  background: #f7fafc;
  border: 2px dotted#e2e8f0;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 16px;
  display: block;
  cursor: pointer;
}

.preview-container {
  display: flex;
  margin-top: 2rem;
}

.preview-card {
  display: flex;
  border: 2px solid #a2a2a2;
  padding: 6px;
  margin-left: 6px;
}

.preview-img {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  border: 1px solid #a2a2a2;
  background-color: #a2a2a2;
}

.table {
  border-color: rgb(225, 225, 225);
  word-wrap: break-word;
}

.table th,
.table td {
  padding: 0;
  padding-bottom: 5px;
  text-align: center;
  word-wrap: break-word;
}

.icon-size {
  font-size: 1.5rem;
  cursor: pointer;
}

.add-x-scroll {
  width: 100%;
  overflow-x: auto;
  margin-bottom: 0;
  -webkit-overflow-scrolling: touch;
}

.truncate-doc-name {
  width: 200px;
}

.logs_Section {
  max-height: 320px;
  overflow-x: hidden;
}

.resizable {
  resize: vertical;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 100px;
  max-height: 80vh; /* optional limit */
  border: 1px solid #ccc; /* so users see where to drag */
  padding: 5px;
}

.number_field {
  border-color: #E8E8E8;
  color: #6F6F6F;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  min-height: 32px;
  border: 2px solid #E8E8E8;
  width: 100%;
}
.cursor-pointer {
  cursor: pointer !important;
}

</style>
